import React from "react";
import { 
  LayoutGrid, 
  PlusSquare, 
  BookOpen, 
  BarChart3, 
  Menu 
} from "lucide-react";

export default function MobileBottomTabs({ activeTab, onChange }) {
  const tabs = [
    { id: "accounts", icon: LayoutGrid, label: "Overview" },   // Synced ID
    { id: "addTrade", icon: PlusSquare, label: "Log Trades" }, // Synced ID
    { id: "journal", icon: BookOpen, label: "Journal" },      // Synced ID
    { id: "dashboard", icon: BarChart3, label: "Dashboard" },  // Synced ID
    { id: "more", icon: Menu, label: "More" },
  ];

  return (
    <div style={styles.container}>
      <nav style={styles.nav}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;

          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              style={styles.tab}
            >
              <div style={{
                ...styles.iconWrapper,
                color: isActive ? "#38bdf8" : "#94a3b8",
                background: isActive ? "rgba(56, 189, 248, 0.15)" : "transparent",
              }}>
                <Icon size={26} strokeWidth={isActive ? 2.5 : 2} />
              </div>
              {isActive && <div style={styles.activeIndicator} />}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

const styles = {
  container: { position: "fixed", bottom: 25, left: "5%", right: "5%", width: "90%", zIndex: 1000 },
  nav: { height: "65px", background: "rgba(15, 23, 42, 0.95)", backdropFilter: "blur(12px)", borderRadius: "24px", border: "1px solid rgba(255, 255, 255, 0.1)", display: "flex", justifyContent: "space-around", alignItems: "center", boxShadow: "0 15px 35px rgba(0,0,0,0.4)" },
  tab: { background: "none", border: "none", display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", position: "relative" },
  iconWrapper: { padding: "10px", borderRadius: "16px", transition: "0.3s cubic-bezier(0.4, 0, 0.2, 1)", display: "flex", alignItems: "center", justifyContent: "center" },
  activeIndicator: { position: "absolute", bottom: -8, width: "4px", height: "4px", borderRadius: "50%", background: "#38bdf8", boxShadow: "0 0 8px #38bdf8" }
};